"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import Text from "@components/atoms/Text";
import assetLoader from "@utils/internalImageLoder";
import styles from "../../organisms/VariantsSection/VariantsSection.module.scss";
import { useGlobalLoader } from "@hooks/useGlobalLoader";
import { CITY_SELECTION_MODAL_APPBAR_CONFIG } from "@utils/appbarConfig";
import { updateAppBar } from "@hooks/useWebviewCallback";
import { PAGE_TYPES } from "@constants/pageTypes";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";

const CompareVariantsBanner: React.FC<any> = ({
  slug,
  make,
  model,
  carAvailability,
  cityName
}) => {
  const router = useRouter();
  const { showLoader } = useGlobalLoader();

  const handleCompareClick = async (slug: string) => {
    updateAppBar(CITY_SELECTION_MODAL_APPBAR_CONFIG);
    showLoader('Loading...');
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: PAGE_TYPES.MM_PAGE,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_add_to_compare",
        car_availability: carAvailability,
        vehicle_make: make,
        vehicle_model: model,
        city_name: cityName,
        Section: "Compare"
      },
    });
    router.push(`/acko-app/compare/${slug}`);
  }

  return (
    <div className={styles.compareVariantsBanner}>
      <div className={styles.compareVariantsIcon}>
        <Image
          src={`${assetLoader()}/icons/compare-cars.webp`}
          alt="compare cars icon"
          width={24}
          height={24}
        />
      </div>
      <div className={styles.compareVariantsContent}>
        <Text className={styles.compareVariantsHeading}>
          Not sure which variant to pick?
        </Text>
        <button
          className={styles.compareVariantsLink}
          onClick={() => handleCompareClick(slug)}
        >
          Compare variants
          <Image
            src={`${assetLoader()}/icons/chevron-right-bold.webp`}
            alt="Chevron_right"
            width={16}
            height={16}
            loading="lazy"
          />
        </button>
      </div>
    </div>
  );
};

export default CompareVariantsBanner;
